import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { LoggingService, ToasterService } from '#services';
import { TranslateService } from '@ngx-translate/core';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  const translateService = inject(TranslateService);
  const log = inject(LoggingService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      log.error('ErrorInterceptor', `HTTP ${error.status} — ${req.method} ${req.url}`, {
        status: error.status,
        statusText: error.statusText,
      });
      switch (error.status) {
        case 401:
          router.navigate(['/unauthorized']);
          break;
        case 403:
          // Let the caller handle 403 when it opted out via this header
          if (!req.headers.has('X-Handle-Forbidden')) {
            router.navigate(['/forbidden']);
          }
          break;
        case 500:
          toasterService.showError(translateService.instant('errors.serverError'));
          break;
        case 0:
          // Allow callers to suppress this toast and handle the status-0 error themselves
          // (e.g. bulk upload shows a "file may be open in Excel" message instead).
          if (!req.headers.has('X-Skip-Error-Toast')) {
            toasterService.showError(translateService.instant('errors.networkError'));
          }
          break;
      }
      return throwError(() => error);
    }),
  );
};
